import { ChevronRight } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { ProviderLogo } from "./ProviderLogo";
import { getEhrProviderTileState } from "@/frontend/utils/dashboard/settings/ehr-providers";
import type { Provider, SavedRow } from "@/frontend/types/ehr-clients";

interface Props {
  provider: Provider;
  savedRow: SavedRow | undefined;
}

export function EhrProviderTile({ provider, savedRow }: Props) {
  const state = getEhrProviderTileState(provider, savedRow);

  if (state.variant === "coming-soon") {
    return (
      <div className="flex items-center gap-3 rounded-xl border bg-card px-4 py-3 opacity-60 cursor-default">
        <div className="flex size-8 items-center justify-center rounded-md border bg-white p-1 shrink-0">
          <ProviderLogo provider={provider.type} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">{provider.label}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{state.subtitle}</p>
        </div>
        <span className="inline-flex items-center rounded-md bg-muted border px-2 py-0.5 text-xs font-medium text-muted-foreground shrink-0">
          Coming soon
        </span>
      </div>
    );
  }

  return (
    <Link
      to="/dashboard/settings"
      search={{ section: "clients", provider: provider.type, destinationId: undefined }}
      className="flex items-center gap-3 rounded-xl border bg-card px-4 py-3 hover:bg-muted/40 transition-colors"
    >
      <div className="flex size-8 items-center justify-center rounded-md border bg-white p-1 shrink-0">
        <ProviderLogo provider={provider.type} />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">{provider.label}</p>
        <p className="text-xs text-muted-foreground mt-0.5">{state.subtitle}</p>
      </div>

      {state.badge === "disabled" ? (
        <span className="inline-flex items-center rounded-md bg-red-50 border border-red-200 px-2 py-0.5 text-xs font-medium text-red-700 shrink-0">
          Disabled
        </span>
      ) : (
        <span className="inline-flex items-center rounded-md bg-green-50 border border-green-200 px-2 py-0.5 text-xs font-medium text-green-700 shrink-0">
          Enabled
        </span>
      )}
      <ChevronRight className="size-4 text-muted-foreground shrink-0" />
    </Link>
  );
}
